import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { useClientId } from '../../../_hooks/useClientId';
import { queryKeys } from './queryKeys';
import { AkoyaDTO } from './useAkoyaAccountsQuery';

interface AkoyaChangeNameBody {
  name: string;
  akoyaTokenId: number;
}

const changeAkoyaName = (clientId: number) => ({ name, akoyaTokenId }: AkoyaChangeNameBody) =>
  authFetch(
    urlWithParams(`/Consumer/AkoyaAccountsUpdate/ChangeName`, {
      clientId,
      name,
      akoyaTokenId,
    }),
    {
      method: 'POST',
    },
  );

export const useAkoyaChangeNameMutation = () => {
  const clientId = useClientId();

  const queryClient = useQueryClient();

  return useMutation(changeAkoyaName(clientId), {
    onSuccess: (data, variables) => {
      const queryKey = queryKeys.akoyaAccounts(clientId);
      const { Accounts } = queryClient.getQueryData(queryKeys.akoyaAccounts(clientId)) as AkoyaDTO;

      queryClient.setQueryData(queryKey, {
        Accounts: Accounts.map(account => {
          if (account.AkoyaTokenId === variables.akoyaTokenId) {
            return { ...account, Name: variables.name };
          }
          return account;
        }),
      });
    },
  });
};
